export const Cart = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CreditCard = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 10H23" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        stroke="#061143"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke="#061143"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Email = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 6L12 13L2 6" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const Password = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#061143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#1CA3FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#1CA3FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Eye = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z"
        stroke={props.stroke || "#061143"}
        strokeLinecap="round"
      />
      <circle cx="12" cy="12" r="3" stroke={props.stroke || "#061143"} strokeLinecap="round" />
    </svg>
  );
};

export const ClosedEye = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 9C20 9 19.6797 9.66735 19 10.5144M12 14C10.392 14 9.04786 13.5878 7.94861 13M12 14C13.608 14 14.9521 13.5878 16.0514 13M12 14V17.5M4 9C4 9 4.35367 9.73682 5.10628 10.6448M7.94861 13L5 16M7.94861 13C6.6892 12.3266 5.75124 11.4228 5.10628 10.6448M16.0514 13L18.5 16M16.0514 13C17.3818 12.2887 18.3535 11.3202 19 10.5144M5.10628 10.6448L2 12M19 10.5144L22 12"
        stroke="#061143"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const CreditCards = () => {
  return (
    <svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.8"
        d="M58.5697 0C90.8944 0 117.139 26.2451 117.139 58.5697C117.139 90.8944 90.8944 117.139 58.5697 117.139C26.2451 117.139 0 90.8944 0 58.5697C0 26.2451 26.2451 0 58.5697 0Z"
        fill="#EFF0F2"
      />
      <g clipPath="url(#clip0_1228_8048)">
        <path d="M83.9442 28.7103L16.9111 48.241L18.6866 54.3349L85.7197 34.8043L83.9442 28.7103Z" fill="#6F7285" />
        <path
          d="M24.9202 76.2325L15.04 42.322C14.9668 42.0706 14.9964 41.8004 15.1224 41.5708C15.2484 41.3412 15.4604 41.1711 15.7118 41.0979L81.1198 22.0407C81.3712 21.9677 81.6413 21.9974 81.8708 22.1233C82.1003 22.2493 82.2704 22.4611 82.3439 22.7124L91.0969 52.7547L90.8261 52.8336L82.0731 22.7913C82.0205 22.6119 81.8989 22.4607 81.735 22.3707C81.5711 22.2808 81.3782 22.2595 81.1986 22.3115L15.7907 41.3687C15.6111 41.421 15.4597 41.5425 15.3697 41.7065C15.2797 41.8705 15.2585 42.0635 15.3109 42.2431L25.191 76.1536L24.9202 76.2325Z"
          fill="#6F7285"
        />
        <path
          d="M76.6194 52.8937C76.421 52.8935 76.2279 52.829 76.0692 52.7099C75.9104 52.5909 75.7945 52.4236 75.7388 52.2331L74.0816 46.5455C74.0139 46.3121 74.0415 46.0613 74.1585 45.8482C74.2754 45.6351 74.4721 45.4771 74.7054 45.4088L80.3931 43.7517C80.6265 43.684 80.8773 43.7116 81.0904 43.8286C81.3035 43.9455 81.4615 44.1422 81.5297 44.3755L83.1869 50.0632C83.2546 50.2966 83.227 50.5474 83.11 50.7605C82.9931 50.9736 82.7964 51.1316 82.5631 51.1998L76.8755 52.857C76.7923 52.8813 76.7061 52.8937 76.6194 52.8937Z"
          fill="#1CA3FF"
        />
        <path
          d="M24.7669 42.4264C24.7499 42.368 24.7296 42.3105 24.7063 42.2543C24.5472 41.8684 24.2512 41.5548 23.875 41.3738C23.4988 41.1929 23.069 41.1573 22.6682 41.274C22.2674 41.3907 21.9238 41.6514 21.7035 42.006C21.4833 42.3606 21.4018 42.7841 21.4748 43.1952C21.4851 43.2551 21.4987 43.3145 21.5157 43.3729C21.6187 43.7245 21.8329 44.0332 22.126 44.2529C22.4192 44.4726 22.7757 44.5914 23.142 44.5916C23.302 44.5919 23.4611 44.5691 23.6146 44.5239C24.0452 44.398 24.4083 44.1066 24.6243 43.7134C24.8404 43.3202 24.8917 42.8574 24.7669 42.4264ZM23.5356 44.253C23.1764 44.3573 22.7906 44.3148 22.4628 44.135C22.1349 43.9552 21.8917 43.6527 21.7865 43.2939C21.77 43.2354 21.7568 43.1761 21.747 43.1162C21.6941 42.7775 21.7664 42.4312 21.9503 42.142C22.1342 41.8527 22.4171 41.6404 22.7462 41.5446C23.0753 41.4488 23.4281 41.4762 23.7384 41.6217C24.0488 41.7671 24.2956 42.0206 24.4326 42.3347C24.4582 42.3899 24.4794 42.447 24.4961 42.5054C24.6002 42.8645 24.5575 43.2503 24.3774 43.578C24.1973 43.9056 23.8945 44.1484 23.5356 44.253V44.253Z"
          fill="#1CA3FF"
        />
        <path
          d="M20.6155 43.6349C20.5253 43.3249 20.5339 42.9944 20.6403 42.6896C20.7467 42.3848 20.9456 42.1207 21.2091 41.9342C20.9622 41.9222 20.716 41.9693 20.4909 42.0717C20.2659 42.1741 20.0686 42.3288 19.9155 42.5229C19.7624 42.717 19.6578 42.9448 19.6106 43.1875C19.5634 43.4302 19.5748 43.6806 19.644 43.9179C19.7131 44.1553 19.838 44.3727 20.0082 44.552C20.1784 44.7313 20.3889 44.8674 20.6223 44.9488C20.8557 45.0303 21.1052 45.0548 21.35 45.0203C21.5948 44.9858 21.8279 44.8934 22.0297 44.7506C21.7072 44.7348 21.3977 44.6189 21.1442 44.4189C20.8907 44.2189 20.7059 43.9448 20.6155 43.6349Z"
          fill="#1CA3FF"
        />
        <path
          d="M64.4632 50.6252C64.4332 50.5172 64.3822 50.4163 64.3131 50.328C64.2441 50.2398 64.1583 50.1661 64.0607 50.1111C63.9631 50.0561 63.8556 50.0208 63.7444 50.0074C63.6331 49.9939 63.5203 50.0026 63.4125 50.0327L54.0481 52.6521L53.0396 52.9342H59.3727L60.3812 52.6521L63.8722 51.676C64.0899 51.6149 64.2743 51.4699 64.3851 51.2728C64.4959 51.0758 64.524 50.8429 64.4632 50.6252Z"
          fill="#CCCCCC"
        />
        <path
          d="M57.8379 48.6689C57.7769 48.4512 57.6319 48.2667 57.4348 48.1559C57.2378 48.045 57.0047 48.017 56.787 48.0779L42.7356 52.0076C42.5392 52.0632 42.3692 52.1872 42.2562 52.3571C42.1432 52.527 42.0946 52.7317 42.1192 52.9343H45.7569L46.7667 52.6522L57.2469 49.7212C57.4647 49.6598 57.6492 49.5146 57.76 49.3173C57.8708 49.12 57.8988 48.8869 57.8379 48.6689Z"
          fill="#CCCCCC"
        />
        <path
          d="M94.0124 52.6519H25.8847C25.6229 52.6521 25.372 52.7563 25.1869 52.9414C25.0018 53.1265 24.8976 53.3774 24.8973 53.6392V93.9798C24.8976 94.2416 25.0017 94.4926 25.1868 94.6777C25.3719 94.8628 25.6229 94.9669 25.8847 94.9672H94.0124C94.2742 94.9669 94.5252 94.8628 94.7103 94.6777C94.8954 94.4926 94.9995 94.2416 94.9998 93.9798V53.6392C94.9995 53.3774 94.8954 53.1265 94.7103 52.9414C94.5252 52.7563 94.2742 52.6522 94.0124 52.6519ZM94.7177 93.9798C94.7176 94.1669 94.6433 94.3462 94.5111 94.4784C94.3788 94.6107 94.1995 94.685 94.0124 94.6851H25.8847C25.6977 94.685 25.5183 94.6107 25.3861 94.4784C25.2538 94.3462 25.1795 94.1669 25.1794 93.9798V53.6392C25.1795 53.4522 25.2538 53.2729 25.3861 53.1406C25.5183 53.0084 25.6977 52.934 25.8847 52.934H94.0124C94.1995 52.934 94.3788 53.0084 94.511 53.1406C94.6433 53.2729 94.7176 53.4522 94.7177 53.6392V93.9798Z"
          fill="#6F7285"
        />
        <path
          d="M32.5137 58.153C32.1789 58.153 31.8516 58.0538 31.5733 57.8678C31.2949 57.6818 31.078 57.4175 30.9499 57.1082C30.8218 56.7989 30.7883 56.4586 30.8536 56.1302C30.9189 55.8019 31.0801 55.5003 31.3168 55.2636C31.5535 55.0269 31.8551 54.8657 32.1834 54.8003C32.5118 54.735 32.8521 54.7686 33.1614 54.8967C33.4707 55.0248 33.735 55.2417 33.921 55.5201C34.107 55.7984 34.2063 56.1257 34.2063 56.4604C34.2058 56.9092 34.0273 57.3394 33.7099 57.6567C33.3926 57.974 32.9624 58.1525 32.5137 58.153ZM32.5137 55.0499C32.2347 55.0499 31.962 55.1326 31.73 55.2876C31.4981 55.4426 31.3173 55.6629 31.2105 55.9207C31.1038 56.1784 31.0758 56.462 31.1303 56.7356C31.1847 57.0092 31.319 57.2606 31.5163 57.4578C31.7135 57.6551 31.9649 57.7894 32.2385 57.8438C32.5121 57.8983 32.7957 57.8703 33.0534 57.7636C33.3112 57.6568 33.5315 57.476 33.6865 57.2441C33.8414 57.0121 33.9242 56.7394 33.9242 56.4604C33.9237 56.0865 33.775 55.728 33.5106 55.4635C33.2461 55.1991 32.8876 55.0503 32.5137 55.0499Z"
          fill="#1CA3FF"
        />
        <path
          d="M29.8824 56.4612C29.8825 56.1384 29.9832 55.8235 30.1707 55.5606C30.3581 55.2977 30.6228 55.0998 30.9281 54.9945C30.6944 54.9139 30.4448 54.8903 30.2001 54.9256C29.9554 54.961 29.7227 55.0543 29.5214 55.1978C29.3201 55.3413 29.156 55.5308 29.0428 55.7506C28.9296 55.9704 28.8705 56.214 28.8705 56.4612C28.8705 56.7084 28.9296 56.9521 29.0428 57.1719C29.156 57.3916 29.3201 57.5811 29.5214 57.7246C29.7227 57.8681 29.9554 57.9615 30.2001 57.9968C30.4448 58.0322 30.6944 58.0086 30.9281 57.928C30.6228 57.8226 30.3581 57.6247 30.1707 57.3618C29.9832 57.0989 29.8825 56.7841 29.8824 56.4612Z"
          fill="#1CA3FF"
        />
        <path
          d="M39.3749 76.4584C39.0384 76.458 38.7157 76.3241 38.4777 76.0861C38.2397 75.8482 38.1059 75.5255 38.1055 75.1889V71.3805C38.1055 71.0439 38.2392 70.721 38.4773 70.4829C38.7154 70.2448 39.0382 70.1111 39.3749 70.1111C39.7116 70.1111 40.0345 70.2448 40.2726 70.4829C40.5106 70.721 40.6444 71.0439 40.6444 71.3805V75.1889C40.644 75.5255 40.5101 75.8481 40.2721 76.0861C40.0342 76.3241 39.7115 76.458 39.3749 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M42.7599 76.4584C42.4234 76.458 42.1007 76.3241 41.8627 76.0861C41.6247 75.8482 41.4909 75.5255 41.4905 75.1889V71.3805C41.4905 71.0439 41.6242 70.721 41.8623 70.4829C42.1004 70.2448 42.4233 70.1111 42.7599 70.1111C43.0966 70.1111 43.4195 70.2448 43.6576 70.4829C43.8956 70.721 44.0294 71.0439 44.0294 71.3805V75.1889C44.029 75.5255 43.8951 75.8481 43.6572 76.0861C43.4192 76.3241 43.0965 76.458 42.7599 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M46.1456 76.4584C45.809 76.458 45.4863 76.3241 45.2483 76.0861C45.0104 75.8482 44.8765 75.5255 44.8761 75.1889V71.3805C44.8761 71.0439 45.0098 70.721 45.2479 70.4829C45.486 70.2448 45.8089 70.1111 46.1456 70.1111C46.4822 70.1111 46.8051 70.2448 47.0432 70.4829C47.2813 70.721 47.415 71.0439 47.415 71.3805V75.1889C47.4146 75.5255 47.2808 75.8481 47.0428 76.0861C46.8048 76.3241 46.4821 76.458 46.1456 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M51.3641 76.4584C51.0275 76.458 50.7048 76.3241 50.4669 76.0861C50.2289 75.8482 50.095 75.5255 50.0946 75.1889V71.3805C50.0946 71.0439 50.2284 70.721 50.4664 70.4829C50.7045 70.2448 51.0274 70.1111 51.3641 70.1111C51.7007 70.1111 52.0236 70.2448 52.2617 70.4829C52.4998 70.721 52.6335 71.0439 52.6335 71.3805V75.1889C52.6331 75.5255 52.4993 75.8481 52.2613 76.0861C52.0233 76.3241 51.7006 76.458 51.3641 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M54.7497 76.4584C54.4131 76.458 54.0905 76.3241 53.8525 76.0861C53.6145 75.8482 53.4806 75.5255 53.4802 75.1889V71.3805C53.4802 71.0439 53.614 70.721 53.852 70.4829C54.0901 70.2448 54.413 70.1111 54.7497 70.1111C55.0864 70.1111 55.4093 70.2448 55.6473 70.4829C55.8854 70.721 56.0191 71.0439 56.0191 71.3805V75.1889C56.0188 75.5255 55.8849 75.8481 55.6469 76.0861C55.4089 76.3241 55.0862 76.458 54.7497 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M58.1347 76.4584C57.7981 76.458 57.4755 76.3241 57.2375 76.0861C56.9995 75.8482 56.8656 75.5255 56.8652 75.1889V71.3805C56.8652 71.0439 56.999 70.721 57.2371 70.4829C57.4751 70.2448 57.798 70.1111 58.1347 70.1111C58.4714 70.1111 58.7943 70.2448 59.0323 70.4829C59.2704 70.721 59.4042 71.0439 59.4042 71.3805V75.1889C59.4038 75.5255 59.2699 75.8481 59.0319 76.0861C58.7939 76.3241 58.4713 76.458 58.1347 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M63.3537 76.4584C63.0171 76.458 62.6945 76.3241 62.4565 76.0861C62.2185 75.8482 62.0846 75.5255 62.0842 75.1889V71.3805C62.0842 71.0439 62.218 70.721 62.456 70.4829C62.6941 70.2448 63.017 70.1111 63.3537 70.1111C63.6904 70.1111 64.0133 70.2448 64.2513 70.4829C64.4894 70.721 64.6231 71.0439 64.6231 71.3805V75.1889C64.6228 75.5255 64.4889 75.8481 64.2509 76.0861C64.0129 76.3241 63.6903 76.458 63.3537 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M66.7388 76.4584C66.4023 76.458 66.0796 76.3241 65.8416 76.0861C65.6036 75.8482 65.4697 75.5255 65.4694 75.1889V71.3805C65.4694 71.0439 65.6031 70.721 65.8412 70.4829C66.0792 70.2448 66.4021 70.1111 66.7388 70.1111C67.0755 70.1111 67.3984 70.2448 67.6365 70.4829C67.8745 70.721 68.0083 71.0439 68.0083 71.3805V75.1889C68.0079 75.5255 67.874 75.8481 67.636 76.0861C67.3981 76.3241 67.0754 76.458 66.7388 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M70.1238 76.4584C69.7873 76.458 69.4646 76.3241 69.2266 76.0861C68.9886 75.8482 68.8548 75.5255 68.8544 75.1889V71.3805C68.8544 71.0439 68.9881 70.721 69.2262 70.4829C69.4643 70.2448 69.7871 70.1111 70.1238 70.1111C70.4605 70.1111 70.7834 70.2448 71.0215 70.4829C71.2595 70.721 71.3933 71.0439 71.3933 71.3805V75.1889C71.3929 75.5255 71.259 75.8481 71.0211 76.0861C70.7831 76.3241 70.4604 76.458 70.1238 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M75.3428 76.4584C75.0063 76.458 74.6836 76.3241 74.4456 76.0861C74.2076 75.8482 74.0737 75.5255 74.0734 75.1889V71.3805C74.0734 71.0439 74.2071 70.721 74.4452 70.4829C74.6833 70.2448 75.0061 70.1111 75.3428 70.1111C75.6795 70.1111 76.0024 70.2448 76.2405 70.4829C76.4785 70.721 76.6123 71.0439 76.6123 71.3805V75.1889C76.6119 75.5255 76.478 75.8481 76.24 76.0861C76.0021 76.3241 75.6794 76.458 75.3428 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M78.728 76.4584C78.3914 76.458 78.0687 76.3241 77.8307 76.0861C77.5928 75.8482 77.4589 75.5255 77.4585 75.1889V71.3805C77.4585 71.0439 77.5922 70.721 77.8303 70.4829C78.0684 70.2448 78.3913 70.1111 78.728 70.1111C79.0646 70.1111 79.3875 70.2448 79.6256 70.4829C79.8637 70.721 79.9974 71.0439 79.9974 71.3805V75.1889C79.997 75.5255 79.8632 75.8481 79.6252 76.0861C79.3872 76.3241 79.0645 76.458 78.728 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M82.1135 76.4584C81.7769 76.458 81.4542 76.3241 81.2162 76.0861C80.9783 75.8482 80.8444 75.5255 80.844 75.1889V71.3805C80.844 71.0439 80.9777 70.721 81.2158 70.4829C81.4539 70.2448 81.7768 70.1111 82.1135 70.1111C82.4501 70.1111 82.773 70.2448 83.0111 70.4829C83.2492 70.721 83.3829 71.0439 83.3829 71.3805V75.1889C83.3825 75.5255 83.2487 75.8481 83.0107 76.0861C82.7727 76.3241 82.45 76.458 82.1135 76.4584Z"
          fill="#1CA3FF"
        />
        <path
          d="M47.9817 90.5876H29.724C29.4977 90.5876 29.2808 90.4977 29.1208 90.3377C28.9608 90.1778 28.871 89.9608 28.871 89.7346C28.871 89.5084 28.9608 89.2914 29.1208 89.1314C29.2808 88.9715 29.4977 88.8816 29.724 88.8816H47.9817C48.2079 88.8816 48.4248 88.9715 48.5848 89.1314C48.7448 89.2914 48.8346 89.5084 48.8346 89.7346C48.8346 89.9608 48.7448 90.1778 48.5848 90.3377C48.4248 90.4977 48.2079 90.5876 47.9817 90.5876Z"
          fill="#E6E6E6"
        />
        <path
          d="M42.1278 86.9196H35.5774C35.3511 86.9196 35.1342 86.8297 34.9742 86.6698C34.8142 86.5098 34.7244 86.2928 34.7244 86.0666C34.7244 85.8404 34.8142 85.6234 34.9742 85.4635C35.1342 85.3035 35.3511 85.2136 35.5774 85.2136H42.1278C42.354 85.2136 42.571 85.3035 42.731 85.4635C42.8909 85.6234 42.9808 85.8404 42.9808 86.0666C42.9808 86.2928 42.8909 86.5098 42.731 86.6698C42.571 86.8297 42.354 86.9196 42.1278 86.9196Z"
          fill="#E6E6E6"
        />
        <path d="M94.6668 61.0845H25.1287V61.3666H94.6668V61.0845Z" fill="#6F7285" />
      </g>
      <defs>
        <clipPath id="clip0_1228_8048">
          <rect width="80" height="72.9671" fill="white" transform="translate(15 22)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const VisaCard = () => {
  return (
    <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1228_8156)">
        <path
          d="M23.0051 0.265137H2.37981C1.21151 0.265137 0.264404 1.21505 0.264404 2.38683V14.5866C0.264404 15.7584 1.21151 16.7083 2.37981 16.7083H23.0051C24.1734 16.7083 25.1205 15.7584 25.1205 14.5866V2.38683C25.1205 1.21505 24.1734 0.265137 23.0051 0.265137Z"
          fill="white"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.530424"
        />
        <path
          d="M2.94863 6.27428C2.3953 5.96989 1.7638 5.72508 1.05774 5.55519L1.08736 5.42289H3.98227C4.37466 5.43668 4.69306 5.5551 4.79667 5.97329L5.42581 8.98172L5.61855 9.88783L7.38066 5.42289H9.28329L6.45508 11.9637H4.55236L2.94863 6.27428ZM10.6828 11.9706H8.88352L10.0089 5.42289H11.8081L10.6828 11.9706ZM17.2055 5.58296L16.9608 6.99687L16.798 6.92734C16.4725 6.79495 16.0427 6.66265 15.4577 6.67663C14.7473 6.67663 14.4287 6.96206 14.4214 7.24073C14.4214 7.54727 14.8068 7.74928 15.4361 8.04888C16.4728 8.51558 16.9536 9.08672 16.9464 9.83209C16.9319 11.1905 15.7027 12.0682 13.8148 12.0682C13.0076 12.0612 12.2301 11.9006 11.808 11.7197L12.0598 10.2499L12.2968 10.3545C12.8817 10.5986 13.2666 10.7028 13.985 10.7028C14.503 10.7028 15.0585 10.5006 15.0655 10.062C15.0655 9.77636 14.8289 9.56722 14.1328 9.24679C13.4517 8.93322 12.5411 8.41087 12.5558 7.47043C12.5635 6.19576 13.8148 5.3042 15.5917 5.3042C16.2877 5.3042 16.8506 5.45048 17.2055 5.58296ZM19.5969 9.65101H21.0925C21.0185 9.32364 20.6778 7.75632 20.6778 7.75632L20.552 7.19213C20.4632 7.43589 20.3078 7.83298 20.3153 7.819C20.3153 7.819 19.7451 9.27485 19.5969 9.65101ZM21.818 5.42289L23.2695 11.9705H21.6036C21.6036 11.9705 21.4405 11.2182 21.3889 10.9883H19.0787C19.0119 11.1624 18.7011 11.9705 18.7011 11.9705H16.8131L19.4857 5.96616C19.6709 5.54121 19.997 5.42289 20.4262 5.42289H21.818Z"
          fill="#171E6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1228_8156">
          <rect width="25.3849" height="16.9736" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MasterCard = () => {
  return (
    <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1228_8157)">
        <path
          d="M24.1412 0H2.98711C1.81881 0 0.871704 0.949915 0.871704 2.12169V14.8519C0.871704 16.0236 1.81881 16.9736 2.98711 16.9736H24.1412C25.3095 16.9736 26.2566 16.0236 26.2566 14.8519V2.12169C26.2566 0.949915 25.3095 0 24.1412 0Z"
          fill="#252525"
        />
        <path
          d="M10.3911 13.7911C13.3118 13.7911 15.6796 11.4163 15.6796 8.48685C15.6796 5.5574 13.3118 3.18262 10.3911 3.18262C7.47029 3.18262 5.10254 5.5574 5.10254 8.48685C5.10254 11.4163 7.47029 13.7911 10.3911 13.7911Z"
          fill="#EB001B"
        />
        <path
          d="M16.7373 13.7911C19.658 13.7911 22.0258 11.4163 22.0258 8.48685C22.0258 5.5574 19.658 3.18262 16.7373 3.18262C13.8165 3.18262 11.4487 5.5574 11.4487 8.48685C11.4487 11.4163 13.8165 13.7911 16.7373 13.7911Z"
          fill="#F79E1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5641 4.24292C14.8487 5.21063 15.6795 6.75134 15.6795 8.4867C15.6795 10.222 14.8487 11.7628 13.5641 12.7305C12.2796 11.7628 11.4487 10.222 11.4487 8.4867C11.4487 6.75134 12.2796 5.21063 13.5641 4.24292Z"
          fill="#FF5F00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1228_8157">
          <rect width="25.3849" height="16.9736" fill="white" transform="translate(0.871704)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AmericanExpressCard = () => {
  return (
    <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1228_8158)">
        <path
          d="M24.0129 0H2.85882C1.69051 0 0.743408 0.949915 0.743408 2.12169V14.8519C0.743408 16.0236 1.69051 16.9736 2.85882 16.9736H24.0129C25.1812 16.9736 26.1283 16.0236 26.1283 14.8519V2.12169C26.1283 0.949915 25.1812 0 24.0129 0Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3017 14.209V8.16064L26.0348 8.1703V9.84103L24.7943 11.1707L26.0348 12.5125V14.2187H24.0541L23.0015 13.0537L21.9564 14.2231L15.3017 14.209Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0186 13.5458V8.82617H20.0086V9.91342H17.3105V10.6514H19.9443V11.7206H17.3105V12.4455H20.0086V13.5458H16.0186Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9886 13.5457L22.1963 11.1832L19.9885 8.82617H21.6973L23.0464 10.322L24.3994 8.82617H26.0347V8.86331L23.874 11.1832L26.0347 13.4787V13.5457H24.3829L23.0099 12.0348L21.651 13.5457H19.9886Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8023 2.79199H18.3895L19.2982 4.86155V2.79199H22.4923L23.0431 4.34249L23.5958 2.79199H26.0348V8.8403H13.145L15.8023 2.79199Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2921 3.44922L14.2042 8.16487H15.6363L16.0302 7.22054H18.1646L18.5582 8.16487H20.0258L17.9466 3.44922H16.2921ZM16.4716 6.16227L17.0977 4.66109L17.7234 6.16227H16.4716Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0062 8.16404V3.44849L22.0192 3.45543L23.0549 6.35443L24.0975 3.44849H26.0347V8.16404L24.7881 8.17511V4.93597L23.6114 8.16404H22.4735L21.2723 4.9249V8.16404H20.0062Z"
          fill="#016FD0"
        />
      </g>
      <defs>
        <clipPath id="clip0_1228_8158">
          <rect width="25.3849" height="16.9736" fill="white" transform="translate(0.743408)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Discover = () => {
  return (
    <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1228_8159)">
        <path
          d="M23.8817 16.7082L23.884 16.7082C24.8942 16.7169 25.723 15.8885 25.7356 14.8562L25.7356 2.1283C25.7315 1.62906 25.5334 1.15219 25.1853 0.802776C24.8381 0.454253 24.37 0.261051 23.8817 0.265212L2.73118 0.265202C2.24511 0.261051 1.77706 0.454253 1.42982 0.802776C1.08169 1.15219 0.883576 1.62906 0.879525 2.12614L0.879517 14.8451C0.883576 15.3443 1.08169 15.8212 1.42982 16.1706C1.77706 16.5191 2.24511 16.7124 2.73343 16.7082H23.8817ZM23.8806 17.2386C23.8802 17.2386 23.8798 17.2386 23.8794 17.2386L23.8817 17.2386H23.8806Z"
          fill="white"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.530424"
        />
        <path
          d="M13.9553 16.9735H23.8817C24.4389 16.9782 24.9751 16.7606 25.3724 16.3688C25.7696 15.9769 25.9954 15.4428 26 14.884V12.3818C22.2517 14.5399 18.1865 16.0896 13.9553 16.9735Z"
          fill="#F27712"
        />
        <path
          d="M25.1248 9.86221H24.2232L23.2078 8.51896H23.1115V9.86221H22.3762V6.52603H23.4616C24.3107 6.52603 24.8009 6.8772 24.8009 7.50932C24.8009 8.02731 24.4945 8.36093 23.9431 8.46628L25.1248 9.86221ZM24.0394 7.53566C24.0394 7.21082 23.7943 7.04401 23.3391 7.04401H23.1115V8.05365H23.3216C23.7943 8.05365 24.0394 7.87806 24.0394 7.53566ZM19.8027 6.52603H21.886V7.08791H20.538V7.83416H21.8335V8.40482H20.538V9.3091H21.886V9.87099H19.8027V6.52603ZM17.4393 9.95L15.8461 6.51725H16.6515L17.6581 8.76478L18.6735 6.51725H19.4613L17.8507 9.95H17.4568H17.4393ZM10.7779 9.94122C9.65748 9.94122 8.78214 9.17741 8.78214 8.18534C8.78214 7.2196 9.67499 6.43823 10.7954 6.43823C11.1105 6.43823 11.3732 6.49969 11.697 6.64016V7.41275C11.4518 7.17106 11.1218 7.03552 10.7779 7.03523C10.0776 7.03523 9.54369 7.54444 9.54369 8.18534C9.54369 8.86135 10.0689 9.34422 10.8129 9.34422C11.1456 9.34422 11.3994 9.23887 11.697 8.97549V9.74808C11.3644 9.88855 11.0843 9.94122 10.7779 9.94122ZM8.55455 8.84379C8.55455 9.49347 8.02059 9.94122 7.25029 9.94122C6.69007 9.94122 6.28741 9.74808 5.94603 9.3091L6.42747 8.89647C6.59378 9.19497 6.87389 9.34422 7.22403 9.34422C7.55666 9.34422 7.793 9.14229 7.793 8.87891C7.793 8.72966 7.72297 8.61553 7.57417 8.52774C7.411 8.44832 7.2411 8.38368 7.06647 8.33459C6.37495 8.1151 6.13861 7.87806 6.13861 7.41275C6.13861 6.86842 6.6463 6.45579 7.31156 6.45579C7.73173 6.45579 8.10813 6.58748 8.42325 6.83331L8.0381 7.27228C7.88545 7.10443 7.66938 7.00882 7.44287 7.00889C7.12774 7.00889 6.90015 7.16692 6.90015 7.37763C6.90015 7.55322 7.03145 7.64979 7.46913 7.79904C8.30945 8.06243 8.55455 8.30825 8.55455 8.85257V8.84379ZM4.93939 6.52603H5.67467V9.87099H4.93939V6.52603ZM2.57596 9.87099H1.49054V6.52603H2.57596C3.76643 6.52603 4.58925 7.21082 4.58925 8.19412C4.58925 8.69454 4.34415 9.16863 3.91524 9.48469C3.54759 9.74808 3.13618 9.87099 2.56721 9.87099H2.57596ZM3.4338 7.36007C3.1887 7.16692 2.90859 7.09669 2.42716 7.09669H2.22583V9.3091H2.42716C2.89984 9.3091 3.19746 9.22131 3.4338 9.04572C3.68765 8.83502 3.83646 8.51896 3.83646 8.19412C3.83646 7.86928 3.68765 7.562 3.4338 7.36007Z"
          fill="black"
        />
        <path
          d="M13.7453 6.43823C12.7824 6.43823 11.9946 7.21082 11.9946 8.16778C11.9946 9.18619 12.7474 9.95 13.7453 9.95C14.7257 9.95 15.496 9.17741 15.496 8.19412C15.496 7.21082 14.7345 6.43823 13.7453 6.43823Z"
          fill="#F27712"
        />
      </g>
      <defs>
        <clipPath id="clip0_1228_8159">
          <rect width="25.3849" height="16.9736" fill="white" transform="translate(0.615112)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PenIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit">
        <path
          id="Rectangle 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5858 4.41421C16.3668 3.63317 17.6332 3.63317 18.4142 4.41421L19.5858 5.58579C20.3668 6.36684 20.3668 7.63316 19.5858 8.41421L8.58579 19.4142C8.21071 19.7893 7.70201 20 7.17157 20L4 20L4 16.8284C4 16.298 4.21071 15.7893 4.58579 15.4142L15.5858 4.41421Z"
          stroke="#061143"
        />
        <path id="Path 9" d="M14 6L18 10" stroke="#061143" />
      </g>
    </svg>
  );
};
export const PayoutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 8H22" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2 12H9C9 13 9.6 15 12 15C14.4 15 15 13 15 12H22"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SettingsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#061143"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
      stroke="#061143"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LogoutIcon = (props) => (
  <svg
    onClick={props.onClick}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Logout</title>
    <path
      d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
      stroke="#061143"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 17L21 12L16 7" stroke="#061143" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 12H9" stroke="#061143" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const LeftArrowIcon = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.25 10.5L1.82071 6.07071C1.78166 6.03166 1.78166 5.96834 1.82071 5.92929L6.25 1.5"
      stroke="#9ba0b4"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const DoubleLeftArrowIcon = () => (
  <div>
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 10.5L1.82071 6.07071C1.78166 6.03166 1.78166 5.96834 1.82071 5.92929L6.25 1.5"
        stroke="#9ba0b4"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 10.5L1.82071 6.07071C1.78166 6.03166 1.78166 5.96834 1.82071 5.92929L6.25 1.5"
        stroke="#9ba0b4"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </div>
);
export const BottomArrowIcon = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.12036 6.71582L9.62036 11.2158L14.1204 6.71582" stroke="#061143" />
  </svg>
);
export const HomeIcon = () => (
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 8L10 1L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8Z"
      stroke="#9ba0b4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BillingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 20V10" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 20V4" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 20V14" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const ShopSettingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 16L12 12L8 16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 12V21" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20.39 18.39C21.3653 17.8583 22.1358 17.0169 22.5798 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9434 10.7355 21.0666 10.0534C20.1898 9.37138 19.1108 9.00073 18 9H16.74C16.4373 7.82924 15.8731 6.74233 15.0899 5.82099C14.3067 4.89965 13.3248 4.16785 12.2181 3.68061C11.1113 3.19336 9.90851 2.96336 8.70008 3.00788C7.49164 3.05241 6.30903 3.3703 5.24114 3.93766C4.17325 4.50503 3.24787 5.3071 2.53458 6.28358C1.82129 7.26006 1.33865 8.38554 1.12294 9.57539C0.90723 10.7653 0.964065 11.9885 1.28917 13.1533C1.61428 14.318 2.1992 15.3939 2.99996 16.3"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 16L12 12L8 16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const DotsIcon = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 7.33341C8.36811 7.33341 8.66659 7.63189 8.66659 8.00008C8.66659 8.36827 8.36811 8.66675 7.99992 8.66675C7.63173 8.66675 7.33325 8.36827 7.33325 8.00008C7.33325 7.63189 7.63173 7.33341 7.99992 7.33341Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 11.9999C8.36811 11.9999 8.66659 12.2984 8.66659 12.6666C8.66659 13.0348 8.36811 13.3333 7.99992 13.3333C7.63173 13.3333 7.33325 13.0348 7.33325 12.6666C7.33325 12.2984 7.63173 11.9999 7.99992 11.9999Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 2.66667C8.36811 2.66667 8.66659 2.96514 8.66659 3.33333C8.66659 3.70152 8.36811 4 7.99992 4C7.63173 4 7.33325 3.70152 7.33325 3.33333C7.33325 2.96514 7.63173 2.66667 7.99992 2.66667Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const StarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99999 15.8441L4.18324 18.9021L5.29414 12.4251L0.58829 7.838L7.09161 6.89301L9.99999 1L12.9084 6.89301L19.4117 7.838L14.7058 12.4251L15.8167 18.9021L9.99999 15.8441Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BalanceCardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 7C2 6.46957 2.21071 5.96086 2.58579 5.58579C2.96086 5.21071 3.46957 5 4 5H20C20.5304 5 21.0391 5.21071 21.4142 5.58579C21.7893 5.96086 22 6.46957 22 7V17C22 17.5304 21.7893 18.0391 21.4142 18.4142C21.0391 18.7893 20.5304 19 20 19H4C3.46957 19 2.96086 18.7893 2.58579 18.4142C2.21071 18.0391 2 17.5304 2 17V7Z"
      stroke="#1CA3FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#1CA3FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 9C3.06087 9 4.07828 8.57857 4.82843 7.82843C5.57857 7.07828 6 6.06087 6 5"
      stroke="#1CA3FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 19C18 17.9391 18.4214 16.9217 19.1716 16.1716C19.9217 15.4214 20.9391 15 22 15"
      stroke="#1CA3FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ExitIcon = ({ onClick }) => (
  <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#777B8F" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 6L18 18" stroke="#777B8F" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const DollarSignIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1V23" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ShoppingCartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AlbumIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="21"
      y="3"
      width="18"
      height="18"
      transform="rotate(90 21 3)"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 14L7 10L18 21" stroke="#061143" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 10C14.8807 10 16 8.88071 16 7.5C16 6.11929 14.8807 5 13.5 5C12.1193 5 11 6.11929 11 7.5C11 8.88071 12.1193 10 13.5 10Z"
      stroke="#061143"
    />
    <path d="M13.5 16.5L21 9" stroke="#061143" />
  </svg>
);
export const PersonIcon = ({ fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke={fill || "white"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke={fill || "white"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PercentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 5L5 19" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.5 9C7.88071 9 9 7.88071 9 6.5C9 5.11929 7.88071 4 6.5 4C5.11929 4 4 5.11929 4 6.5C4 7.88071 5.11929 9 6.5 9Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AnalyticsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 20V10" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 20V4" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 20V14" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const SalesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 4.5C1.5 4.10218 1.65804 3.72064 1.93934 3.43934C2.22064 3.15804 2.60218 3 3 3H15C15.3978 3 15.7794 3.15804 16.0607 3.43934C16.342 3.72064 16.5 4.10218 16.5 4.5V13.5C16.5 13.8978 16.342 14.2794 16.0607 14.5607C15.7794 14.842 15.3978 15 15 15H3C2.60218 15 2.22064 14.842 1.93934 14.5607C1.65804 14.2794 1.5 13.8978 1.5 13.5V4.5Z"
      stroke="#00BE5F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.5 6H16.5" stroke="#00BE5F" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1.5 9H6.75C6.75 9.75 7.2 11.25 9 11.25C10.8 11.25 11.25 9.75 11.25 9H16.5"
      stroke="#00BE5F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FeesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 22C5.25329 22 1 17.5228 1 12C1 6.47715 5.25329 2 10.5 2C15.7467 2 20 6.47715 20 12C20 17.5228 15.7467 22 10.5 22Z"
      stroke="#FF1D4E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 8.8C12.3635 8.2839 11.5694 8.00154 10.75 8C8.679 8 7 9.79 7 12C7 14.21 8.679 16 10.75 16C11.594 16 12.373 15.702 13 15.2"
      stroke="#FF1D4E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 2C14.333 2 23 3 23 12C23 21 14.333 22 10 22"
      stroke="#FF1D4E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FilterArrowDown = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-down">
      <path id="Path 2" d="M12 3V21" stroke="#061143" strokeLinecap="round" />
      <path id="Path 3" d="M6 15L12 21L18 15" stroke="#061143" strokeLinecap="round" />
    </g>
  </svg>
);

export const SortingDownArrow = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.83301 5L9.16314 0.5H0.502881L4.83301 5Z" fill="#9fa3af" />
  </svg>
);

export const SortingUpArrow = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.83301 0L9.16314 4.5H0.502881L4.83301 0Z" fill="#9fa3af" />
  </svg>
);

export const EmailIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
      stroke={color || "#061143"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 6L12 13L2 6" stroke={color || "#061143"} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const LineChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="line-chart">
      <path id="Path 13" d="M3 16L8 11" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
      <path
        id="Oval"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z"
        stroke="#061143"
      />
      <path
        id="Oval Copy"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16Z"
        stroke="#061143"
      />
      <path id="Path 13_2" d="M10 11L13 14" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
      <path id="Path 13_3" d="M15 14L21 8" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export const CalenderIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="calendar">
      <path id="Rectangle" d="M3.5 5H21.5V21H3.5V5Z" stroke="#6F7285" strokeLinejoin="round" />
      <path id="Path 2" d="M21.5 9H3.5" stroke="#6F7285" strokeLinecap="round" />
      <path id="Path 17" d="M7.5 5V3" stroke="#6F7285" strokeLinecap="round" />
      <path id="Path 17_2" d="M17.5 5V3" stroke="#6F7285" strokeLinecap="round" />
    </g>
  </svg>
);

export const BorderUserIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="user">
      <path
        id="Path 4"
        d="M6 19.5C6 19.5 9.5 18 10.5 17C11.5 16 8.5 16 8.5 11C8.5 6 12.5 6 12.5 6C12.5 6 16.5 6 16.5 11C16.5 16 13.5 16 14.5 17C15.5 18 19 19.5 19 19.5"
        stroke="#061143"
        strokeLinecap="round"
      />
      <path
        id="Oval"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
        stroke="#061143"
      />
    </g>
  </svg>
);

export const ZoomOutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.58789 14.4121L4 20" stroke="#061143" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 16C10.6863 16 8 13.3137 8 10C8 6.68629 10.6863 4 14 4C17.3137 4 20 6.68629 20 10C20 13.3137 17.3137 16 14 16Z"
      stroke="#061143"
    />
    <path d="M16.6667 10.0002H11.3334" stroke="#061143" strokeLinecap="round" />
  </svg>
);

export const ZoomInIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.58789 14.4121L4 20" stroke="#061143" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 16C10.6863 16 8 13.3137 8 10C8 6.68629 10.6863 4 14 4C17.3137 4 20 6.68629 20 10C20 13.3137 17.3137 16 14 16Z"
      stroke="#061143"
    />
    <path d="M16.6667 9.99984H11.3334" stroke="#061143" strokeLinecap="round" />
    <path d="M14 7.3335V12.6668" stroke="#061143" strokeLinecap="round" />
  </svg>
);

export const CloseIcon = ({ onClick }) => (
  <svg onClick={onClick} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.82959 7.82959L23.4888 23.4888" stroke="#061143" strokeWidth="2" />
    <path d="M23.4885 7.82959L7.82935 23.4888" stroke="#061143" strokeWidth="2" />
  </svg>
);

export const TriangleIcon = () => (
  <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 0L10.2631 8.25H0.73686L5.5 0Z" fill="#9FA2AF" />
  </svg>
);

export const PlusIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 26.25C7.2457 26.25 1.75 20.7543 1.75 14C1.75 7.2457 7.2457 1.75 14 1.75C20.7543 1.75 26.25 7.2457 26.25 14C26.25 20.7543 20.7543 26.25 14 26.25Z"
      fill="#DFF0FE"
    />
    <path
      d="M14 2.10002C20.5618 2.10002 25.9 7.43823 25.9 14C25.9 20.5618 20.5618 25.9 14 25.9C7.43823 25.9 2.10002 20.5618 2.10002 14C2.10002 7.43823 7.43823 2.10002 14 2.10002ZM14 1.40002C7.04132 1.40002 1.40002 7.04132 1.40002 14C1.40002 20.9587 7.04132 26.6 14 26.6C20.9587 26.6 26.6 20.9587 26.6 14C26.6 7.04132 20.9587 1.40002 14 1.40002Z"
      fill="#1CA3FF"
    />
    <path
      d="M6.99999 13.3H21C21.3864 13.3 21.7 13.6136 21.7 14C21.7 14.3864 21.3864 14.7 21 14.7H6.99999C6.61359 14.7 6.29999 14.3864 6.29999 14C6.29999 13.6136 6.61359 13.3 6.99999 13.3Z"
      fill="#1CA3FF"
    />
    <path
      d="M14.7 7.00005V21C14.7 21.3864 14.3864 21.7 14 21.7C13.6136 21.7 13.3 21.3864 13.3 21V7.00005C13.3 6.61365 13.6136 6.30005 14 6.30005C14.3864 6.30005 14.7 6.61365 14.7 7.00005Z"
      fill="#1CA3FF"
    />
  </svg>
);

export const CheckMark = () => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.61502 9.81137L0.470825 5.66717L1.74402 4.39457L4.61502 7.26557L11.8708 0.00976562L13.144 1.28237L4.61502 9.81137Z"
      fill="white"
    />
  </svg>
);

export const PlayButton = () => (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 0.855011L14.98 9.00001L0.5 17.145V0.855011Z" fill="#ffffff" />
  </svg>
);
export const CurvedPlayButton = () => (
  <svg width="23" height="28" viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5708 13.1425C22.2182 13.5309 22.2182 14.4691 21.5708 14.8575L2.0145 26.5913C1.34797 26.9912 0.5 26.5111 0.5 25.7338L0.5 2.26619C0.5 1.4889 1.34797 1.00878 2.0145 1.4087L21.5708 13.1425Z"
      stroke="white"
      strokeLinejoin="round"
    />
  </svg>
);

export const PauseIcon = () => (
  <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="4" height="16" fill="white" />
    <rect x="7" width="4" height="16" fill="white" />
  </svg>
);

export const PaymentIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4423_10126)">
      <path
        d="M19.0223 35.9997C17.0291 35.4618 15.0359 34.9279 13.0427 34.3901C12.3308 34.1963 11.6229 33.9986 10.915 33.8008C10.3574 33.6427 9.82749 33.7059 9.31733 33.9709C9.11168 34.0777 8.91395 34.2121 8.70039 34.2991C8.32469 34.4573 8.05577 34.6432 8.08741 35.1336C8.11114 35.4618 7.84617 35.6675 7.51001 35.6596C5.96766 35.6279 4.42136 35.5923 2.87901 35.5409C2.44004 35.5251 2.2423 35.2799 2.25417 34.8212C2.32931 32.0608 2.4084 29.3043 2.48749 26.5439C2.50331 25.9705 2.51518 25.397 2.531 24.8236C2.54681 24.3095 2.75641 24.1078 3.27449 24.1196C4.71401 24.1513 6.14958 24.1869 7.58911 24.2264C8.23373 24.2422 8.41169 24.4479 8.38797 25.0965C8.38006 25.3179 8.38797 25.5354 8.38797 25.7609C8.89022 25.5829 9.38456 25.3772 9.89868 25.2349C11.7416 24.7287 13.5529 24.8592 15.2494 25.7371C16.3409 26.3027 17.4562 26.5834 18.6782 26.5795C19.7539 26.5755 20.8296 26.6388 21.9053 26.6586C23.3369 26.6823 24.4442 27.2834 25.2114 28.4975C25.2352 28.5371 25.2668 28.5727 25.3103 28.632C25.6267 28.4857 25.9431 28.3393 26.2555 28.1891C27.5131 27.5959 28.7628 26.9868 30.0283 26.4094C31.3571 25.8004 32.9153 26.2552 33.722 27.4535C34.0424 27.932 33.987 28.2286 33.5124 28.5371C30.1074 30.7399 26.7024 32.9466 23.2894 35.1375C22.5499 35.6121 21.6957 35.7901 20.8375 35.9245C20.7228 35.9404 20.6121 35.972 20.4974 35.9957C20.007 35.9997 19.5166 35.9997 19.0223 35.9997ZM8.18628 33.1799C8.23373 33.1839 8.25746 33.1958 8.27723 33.1879C8.37215 33.1444 8.47101 33.1009 8.55802 33.0494C9.47552 32.4997 10.4405 32.4206 11.4608 32.7212C12.58 33.0534 13.7031 33.3658 14.8302 33.6743C16.2025 34.046 17.5669 34.485 18.9629 34.746C20.2759 34.9912 21.6047 34.8053 22.7516 34.0816C25.9114 32.0805 29.0396 30.028 32.1797 27.9953C32.2706 27.936 32.3576 27.8727 32.4684 27.7896C31.8396 27.2992 31.2029 27.1925 30.5187 27.4851C30.0876 27.667 29.6724 27.8766 29.2492 28.0783C28.0668 28.6359 26.8882 29.1975 25.6939 29.763C25.7137 29.9252 25.7335 30.0755 25.7453 30.2258C25.7888 30.8743 25.5713 31.1037 24.9227 31.0918C23.7403 31.0642 22.5618 31.0365 21.3793 31.0009C20.3155 30.9732 19.2516 30.9416 18.1878 30.8981C17.7488 30.8783 17.4839 30.554 17.5748 30.1862C17.6539 29.8698 17.8793 29.7235 18.3065 29.7354C19.9556 29.7789 21.6047 29.8263 23.2538 29.8698C23.6612 29.8817 24.0685 29.8698 24.4758 29.8698C24.3493 28.8337 23.3092 27.9122 22.1861 27.8569C21.4505 27.8213 20.7149 27.8094 19.9754 27.7857C19.1211 27.758 18.2669 27.754 17.4166 27.6987C16.4398 27.6354 15.5856 27.1925 14.7155 26.7851C12.6433 25.8162 10.5987 25.927 8.60152 27.0501C8.40378 27.1608 8.32469 27.2874 8.32073 27.5168C8.27723 29.3399 8.22187 31.163 8.17046 32.9862C8.1665 33.0494 8.17837 33.1167 8.18628 33.1799ZM6.9524 34.4099C7.03545 31.4359 7.11849 28.4303 7.20154 25.3693C6.01512 25.3693 4.87616 25.3693 3.70555 25.3693C3.6225 28.3552 3.53945 31.3529 3.4564 34.4099C4.63096 34.4099 5.76993 34.4099 6.9524 34.4099Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
      <path
        d="M18.4608 24.9975C13.7388 24.9975 9.90669 21.1733 9.91065 16.4592C9.91065 11.7491 13.7507 7.91699 18.4648 7.91699C23.1867 7.91699 27.0149 11.7452 27.0149 16.4592C27.0149 21.1733 23.1828 24.9975 18.4608 24.9975ZM18.4727 23.8269C22.5579 23.8151 25.8483 20.5049 25.8324 16.4197C25.8166 12.374 22.5223 9.0955 18.4687 9.0955C14.3874 9.09155 11.0852 12.3977 11.0931 16.479C11.0971 20.5366 14.4151 23.8388 18.4727 23.8269Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
      <path
        d="M19.0461 3.43227C19.0461 4.35768 19.054 5.27914 19.0422 6.20455C19.0382 6.67911 18.6428 6.9599 18.2433 6.7938C17.9546 6.67516 17.8755 6.42997 17.8755 6.13732C17.8795 5.20004 17.8755 4.26672 17.8755 3.32945C17.8755 2.47523 17.8716 1.621 17.8755 0.770733C17.8795 0.319893 18.1089 0.0549243 18.4727 0.0667885C18.8247 0.074698 19.0382 0.331756 19.0422 0.766778C19.0501 1.65659 19.0461 2.54641 19.0461 3.43227Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
      <path
        d="M22.2968 4.90737C22.2968 4.48817 22.2889 4.06501 22.3007 3.64581C22.3126 3.25429 22.5578 3.00514 22.9018 3.01701C23.234 3.02887 23.4595 3.27011 23.4634 3.64977C23.4713 4.50399 23.4713 5.35821 23.4634 6.20848C23.4595 6.58814 23.2261 6.82938 22.8979 6.83729C22.5538 6.8452 22.3086 6.6 22.3007 6.20453C22.2889 5.77346 22.2968 5.33844 22.2968 4.90737Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
      <path
        d="M14.6247 4.94297C14.6247 5.36217 14.6326 5.78532 14.6208 6.20453C14.6129 6.59605 14.3677 6.84915 14.0236 6.83729C13.6954 6.82938 13.462 6.58418 13.4581 6.20848C13.4502 5.35426 13.4502 4.50003 13.4581 3.64977C13.462 3.25429 13.7112 3.00514 14.0552 3.01701C14.3874 3.02492 14.6129 3.26616 14.6208 3.64581C14.6326 4.07688 14.6247 4.5119 14.6247 4.94297Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
      <path
        d="M17.1279 14.4944C17.1319 15.1588 17.6025 15.7006 18.2669 15.7994C18.5437 15.839 18.8285 15.8469 19.0974 15.9141C20.1415 16.1751 20.8731 17.057 20.9759 18.1525C21.0708 19.161 20.4737 20.2169 19.5127 20.6084C19.1172 20.7705 18.9076 20.9287 18.955 21.3875C18.9867 21.7039 18.7019 21.9372 18.4014 21.9451C18.1008 21.953 17.8556 21.7276 17.8121 21.4073C17.8003 21.3163 17.7884 21.2174 17.8042 21.1265C17.8477 20.8615 17.7291 20.7468 17.4878 20.644C16.5703 20.2525 16.072 19.5288 15.9534 18.548C15.898 18.0971 16.1234 17.7808 16.4912 17.7531C16.8472 17.7254 17.0884 17.9824 17.1319 18.4254C17.1991 19.161 17.7528 19.6632 18.4884 19.6632C19.1726 19.6593 19.746 19.1293 19.7974 18.4491C19.8528 17.7293 19.3742 17.1124 18.6387 17.0254C18.1008 16.9621 17.5709 16.9147 17.1042 16.5983C16.2895 16.0486 15.8862 15.2735 15.9573 14.3006C16.0325 13.3 16.5624 12.5684 17.4957 12.1729C17.7488 12.0662 17.8398 11.9436 17.8042 11.6865C17.7923 11.5955 17.8003 11.5006 17.8161 11.4057C17.8596 11.1012 18.0969 10.8916 18.3895 10.8916C18.6901 10.8916 18.9906 11.1249 18.955 11.4374C18.9036 11.904 19.137 12.0464 19.5166 12.2164C20.4183 12.608 20.881 13.3554 20.9759 14.3243C21.0194 14.7435 20.7742 15.052 20.4143 15.0718C20.0742 15.0876 19.8369 14.8305 19.7974 14.4113C19.7262 13.6599 19.137 13.1142 18.4212 13.1458C17.6895 13.1774 17.124 13.7667 17.1279 14.4944Z"
        fill="white"
        style={{ stroke: "unset" }}
      />
    </g>
    <defs>
      <clipPath id="clip0_4423_10126">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LeftArrow2 = ({ ...props }) => (
  <svg
    onClick={props.onClick}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Back to settings</title>
    <path d="M21 12L3 12" stroke={props.color || "#061143"} strokeLinecap="round" />
    <path d="M9 6L3 12L9 18" stroke={props.color || "#061143"} strokeLinecap="round" />
  </svg>
);

export const PaperPlane = () => (
  <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M64.5263 110.625H39.375V85.4737L7.2 53.2987L143.239 6.76123L96.7013 142.8L64.5263 110.625Z" fill="white" />
    <path
      d="M140.228 9.7725L95.8988 139.346L66.4013 109.849L65.3025 108.75H63.75H41.25V86.25V84.6975L40.1512 83.5987L10.6538 54.1012L140.228 9.7725ZM146.25 3.75L3.75 52.5L37.5 86.25V112.5H63.75L97.5 146.25L146.25 3.75Z"
      fill="#2083DD"
    />
    <path d="M43.125 106.875V85.6762L119.205 30.7949L64.3237 106.875H43.125Z" fill="#DFF0FE" />
    <path
      d="M110.906 39.0938L63.3637 105H45V86.6363L110.906 39.0938ZM127.5 22.5L41.25 84.7162V86.25V108.75H63.75H65.2838L127.5 22.5Z"
      fill="#DFF0FE"
    />
    <path d="M41.25 84.7162V86.25V108.75L127.5 22.5L41.25 84.7162Z" fill="#B6DCFE" />
  </svg>
);

export const GreenCheckMark = () => (
  <svg width="168" height="131" viewBox="0 0 168 131" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M151.039 2.66705C147.973 -0.405945 142.975 -0.405945 139.902 2.66705L60.2978 82.278L28.0978 50.078C25.0318 47.0051 20.0338 47.0051 16.9608 50.078L2.30983 64.736C-0.75617 67.802 -0.75617 72.8 2.30983 75.873L53.8578 127.421C55.5798 129.143 57.8688 130.095 60.2978 130.095C62.7268 130.095 65.0158 129.143 66.7378 127.421L165.69 28.455C168.756 25.389 168.756 20.3911 165.69 17.3181L151.039 2.66705ZM160.741 23.5061L61.7888 122.472C60.9978 123.277 59.6118 123.277 58.8138 122.472L7.25883 70.924C6.91583 70.581 6.91583 70.028 7.25883 69.685L21.9168 55.027C22.0638 54.88 22.3018 54.81 22.5328 54.81C22.7638 54.81 23.0018 54.887 23.1488 55.027L57.8268 89.698C59.1428 91.014 61.4668 91.014 62.7758 89.698L144.851 7.61605C145.194 7.27305 145.747 7.27305 146.09 7.61605L160.748 22.2741C161.084 22.6101 161.084 23.17 160.741 23.5061Z"
      fill="#00EE98"
    />
  </svg>
);

export const FormCheck = () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 11.5C8.76142 11.5 11 9.26142 11 6.5C11 3.73858 8.76142 1.5 6 1.5C3.23858 1.5 1 3.73858 1 6.5C1 9.26142 3.23858 11.5 6 11.5Z"
        stroke="#9FA2AF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.5 5L4.54912 8.50806L2.5 6.45894" stroke="#9FA2AF" />
    </svg>
  );
};

export const TrashIcon = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    cursor={"pointer"}
    {...props}
  >
    <path d="M19 6H5" stroke="#FF1D4E" strokeLinecap="round" />
    <path d="M14 5H10" stroke="#FF1D4E" strokeLinecap="round" />
    <path d="M6 10V21H18C18 20 18 10 18 10" stroke="#FF1D4E" strokeLinecap="round" />
  </svg>
);

export const ChatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.82388 18.5881L8.95321 18.1051C8.83515 18.0735 8.7096 18.0862 8.60028 18.1408L8.82388 18.5881ZM4 21L3.50503 20.9293C3.47872 21.1134 3.55678 21.2969 3.70764 21.4056C3.85851 21.5144 4.05727 21.5304 4.22361 21.4472L4 21ZM4.65323 16.4274L5.1482 16.4981C5.17225 16.3298 5.10909 16.1607 4.98053 16.0494L4.65323 16.4274ZM12 19.5C17.6891 19.5 22.5 15.7928 22.5 11H21.5C21.5 15.0438 17.3566 18.5 12 18.5V19.5ZM8.69456 19.071C9.73485 19.3496 10.8463 19.5 12 19.5V18.5C10.9331 18.5 9.90864 18.3609 8.95321 18.1051L8.69456 19.071ZM4.22361 21.4472L9.04749 19.0353L8.60028 18.1408L3.77639 20.5528L4.22361 21.4472ZM4.15825 16.3567L3.50503 20.9293L4.49497 21.0707L5.1482 16.4981L4.15825 16.3567ZM1.5 11C1.5 13.2639 2.589 15.3014 4.32593 16.8054L4.98053 16.0494C3.42358 14.7012 2.5 12.9254 2.5 11H1.5ZM12 2.5C6.31089 2.5 1.5 6.20723 1.5 11H2.5C2.5 6.95621 6.64341 3.5 12 3.5V2.5ZM22.5 11C22.5 6.20723 17.6891 2.5 12 2.5V3.5C17.3566 3.5 21.5 6.95621 21.5 11H22.5Z"
      fill="#061143"
    />
  </svg>
);

export const PrintIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="17"
      y="14"
      width="7"
      height="10"
      transform="rotate(90 17 14)"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7 18H3V9H21V18H17" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 9V3H17V9" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TeamIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="people">
      <path
        id="Stroke 1 Copy"
        d="M1 18C1 15.75 4 15.75 5.5 14.25C6.25 13.5 4 13.5 4 9.75C4 7.25025 4.99975 6 7 6C9.00025 6 10 7.25025 10 9.75C10 13.5 7.75 13.5 8.5 14.25C10 15.75 13 15.75 13 18"
        stroke="#061143"
        strokeLinecap="round"
      />
      <path
        id="Stroke 1 Copy 2"
        d="M11.9946 16.2431C12.5616 15.8523 13.2977 15.571 14.002 15.2318C14.5527 14.9665 15.084 14.6659 15.4999 14.25C16.2499 13.5 13.9999 13.5 13.9999 9.75C13.9999 7.25025 14.9996 6 16.9999 6C19.0001 6 19.9999 7.25025 19.9999 9.75C19.9999 13.5 17.7499 13.5 18.4999 14.25C19.9999 15.75 22.9999 15.75 22.9999 18"
        stroke="#061143"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
export const ImageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="21"
      y="3"
      width="18"
      height="18"
      transform="rotate(90 21 3)"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 14L7 10L18 21" stroke="#061143" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 10C14.8807 10 16 8.88071 16 7.5C16 6.11929 14.8807 5 13.5 5C12.1193 5 11 6.11929 11 7.5C11 8.88071 12.1193 10 13.5 10Z"
      stroke="#061143"
    />
    <path d="M13.5 16.5L21 9" stroke="#061143" />
  </svg>
);

export const TrashIconFill = (props) => (
  <svg
    onClick={props.onClick}
    className={props.className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 6H5H21" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 11V17" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 11V17" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CertificateIcon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8 19.9L16.3 24.4L26.2 14.5M19 37C21.5398 37 23.67 35.2467 24.2463 32.8844C24.334 32.5251 24.792 32.3354 25.108 32.5275C27.1859 33.7903 29.932 33.5238 31.7279 31.728C33.5238 29.9321 33.7903 27.1859 32.5274 25.108C32.3353 24.792 32.525 24.334 32.8843 24.2463C35.2466 23.67 37 21.5398 37 19C37 16.4602 35.2467 14.33 32.8844 13.7537C32.5251 13.666 32.3354 13.208 32.5275 12.892C33.7903 10.8141 33.5238 8.06797 31.728 6.27209C29.9321 4.4762 27.1859 4.2097 25.108 5.47259C24.792 5.66467 24.334 5.47496 24.2463 5.11566C23.67 2.75336 21.5398 1 19 1C16.4602 1 14.33 2.75334 13.7537 5.11561C13.666 5.47491 13.208 5.6646 12.892 5.47253C10.8141 4.20965 8.06797 4.47616 6.27209 6.27204C4.4762 8.06793 4.2097 10.8141 5.47259 12.892C5.66467 13.208 5.47496 13.666 5.11566 13.7537C2.75336 14.33 1 16.4602 1 19C1 21.5398 2.75333 23.67 5.11561 24.2463C5.4749 24.334 5.6646 24.792 5.47252 25.108C4.20965 27.1859 4.47616 29.932 6.27204 31.7279C8.06793 33.5238 10.8141 33.7903 12.892 32.5274C13.208 32.3353 13.666 32.525 13.7537 32.8843C14.33 35.2466 16.4602 37 19 37Z"
      stroke="#061143"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CurvedCheckMark = ({ stroke }) => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5L4 8L11 1" stroke={stroke || "#000000"} strokeLinecap="round" />
  </svg>
);

export const LeftLinesIcon = ({ stroke, onClick, className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <rect width="24" height="24" rx="3" fill="white" />
    <line x1="5" y1="7.5" x2="19" y2="7.5" stroke={"#061143"} />
    <line x1="5" y1="11.5" x2="15" y2="11.5" stroke={"#061143"} />
    <line x1="5" y1="15.5" x2="15" y2="15.5" stroke={"#061143"} />
  </svg>
);

export const CenterdLinesIcon = ({ stroke, onClick, className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <rect width="24" height="24" rx="3" fill="white" />
    <line x1="5" y1="7.5" x2="19" y2="7.5" stroke={"#061143"} />
    <line x1="8" y1="11.5" x2="16" y2="11.5" stroke={"#061143"} />
    <line x1="7" y1="15.5" x2="17" y2="15.5" stroke={"#061143"} />
  </svg>
);

export const RightLinesIcon = ({ stroke, onClick, className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <rect width="24" height="24" rx="3" fill="white" />
    <line x1="4" y1="7.5" x2="18" y2="7.5" stroke={"#061143"} />
    <line x1="10" y1="11.5" x2="18" y2="11.5" stroke={"#061143"} />
    <line x1="8" y1="15.5" x2="18" y2="15.5" stroke={"#061143"} />
  </svg>
);

export const FiveStarsIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#C5F6D3" />
    <circle cx="27.8785" cy="28.1214" r="11.6214" stroke="#061143" />
    <path
      d="M24.514 25.7629C24.514 24.5142 23.5018 23.502 22.2531 23.502C21.0044 23.502 19.9922 24.5142 19.9922 25.7629"
      stroke="#061143"
      strokeLinecap="round"
    />
    <path
      d="M27.8788 34.1309C25.1458 34.1309 22.9002 32.0441 22.6485 29.3771L33.1091 29.3771C32.8573 32.0441 30.6117 34.1309 27.8788 34.1309Z"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.5553 25.7629C35.5553 24.5142 34.543 23.502 33.2944 23.502C32.0457 23.502 31.0334 24.5142 31.0334 25.7629"
      stroke="#061143"
      strokeLinecap="round"
    />
  </svg>
);

export const FourStarsIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#C5F6D3" />
    <circle cx="28.1214" cy="28.1214" r="11.6214" stroke="#061143" />
    <path
      d="M24.8588 30.9792C24.9005 30.9375 24.9681 30.9375 25.0098 30.9792C26.729 32.6983 29.5163 32.6983 31.2354 30.9792C31.2771 30.9375 31.3447 30.9375 31.3864 30.9792C31.4281 31.0209 31.4281 31.0885 31.3864 31.1302C29.5839 32.9328 26.6613 32.9328 24.8588 31.1302C24.8171 31.0885 24.8171 31.0209 24.8588 30.9792Z"
      fill="#061143"
      stroke="#061143"
      strokeLinecap="round"
    />
    <circle cx="22.738" cy="25.9238" r="1.29684" stroke="#061143" />
    <circle cx="33.5048" cy="25.9238" r="1.29684" stroke="#061143" />
  </svg>
);
export const ThreeStarsIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#FAF9DA" />
    <circle cx="28.1214" cy="28.1214" r="11.6214" stroke="#061143" />
    <path d="M23.9868 32.3496H32.2293" stroke="#061143" strokeLinecap="round" />
    <circle cx="22.737" cy="25.9238" r="1.29684" stroke="#061143" />
    <circle cx="33.5046" cy="25.9238" r="1.29684" stroke="#061143" />
  </svg>
);
export const TwoStarsIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#FAF9DA" />
    <circle cx="28.1214" cy="28.1214" r="11.6214" stroke="#061143" />
    <path
      d="M31.3854 33.3782C31.3436 33.4199 31.276 33.4199 31.2343 33.3782C29.5152 31.6591 26.7279 31.6591 25.0087 33.3782C24.967 33.4199 24.8994 33.4199 24.8577 33.3782C24.816 33.3365 24.816 33.2689 24.8577 33.2272C26.6603 31.4247 29.5828 31.4247 31.3854 33.2272C31.4271 33.2689 31.4271 33.3365 31.3854 33.3782Z"
      fill="#061143"
      stroke="#061143"
      strokeLinecap="round"
    />
    <circle cx="22.7375" cy="25.9238" r="1.29684" stroke="#061143" />
    <circle cx="33.5034" cy="25.9238" r="1.29684" stroke="#061143" />
  </svg>
);
export const OneStarIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#FFC8D9" />
    <circle cx="28.1214" cy="28.1214" r="11.6214" stroke="#061143" />
    <path
      d="M31.3846 33.554C31.3429 33.5957 31.2753 33.5957 31.2336 33.554C29.5144 31.8349 26.7271 31.8349 25.008 33.554C24.9663 33.5957 24.8987 33.5957 24.857 33.554C24.8153 33.5123 24.8153 33.4447 24.857 33.403C26.6595 31.6004 29.5821 31.6004 31.3846 33.403C31.4263 33.4447 31.4263 33.5123 31.3846 33.554Z"
      fill="#061143"
      stroke="#061143"
      strokeLinecap="round"
    />
    <circle cx="22.7373" cy="28.8066" r="1.29684" stroke="#061143" />
    <circle cx="33.5036" cy="28.8066" r="1.29684" stroke="#061143" />
  </svg>
);

export const LinkIcon = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.25 14.625V21.375C20.25 21.9717 20.0129 22.544 19.591 22.966C19.169 23.3879 18.5967 23.625 18 23.625H5.625C5.02826 23.625 4.45597 23.3879 4.03401 22.966C3.61205 22.544 3.375 21.9717 3.375 21.375V9C3.375 8.40326 3.61205 7.83097 4.03401 7.40901C4.45597 6.98705 5.02826 6.75 5.625 6.75H12.375"
      stroke="#061143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.875 3.375H23.625V10.125" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.25 15.75L23.625 3.375" stroke="#061143" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PhotoBackdropIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="42"
      y="6"
      width="36"
      height="36"
      transform="rotate(90 42 6)"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M42 6L6 42" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32 6L6 32" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 6L6 22" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 6L6 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ThreeAlbumsIcon = () => (
  <svg width="59" height="52" viewBox="0 0 59 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.602 45.6606L15.9412 48.6785C13.8335 49.4046 12.4966 48.7834 11.9323 46.8168C11.3696 44.8467 8.2743 35.4781 2.64798 18.7127C2.26601 16.5104 3.03683 15.158 4.95701 14.6556C4.95701 14.6556 6.74642 14.1119 10.3235 13.0176"
      stroke="#E5E6EB"
      strokeWidth="1.72059"
    />
    <path
      d="M27.0803 39.3933C26.5624 40.9934 26.953 42.1084 28.252 42.7416C29.5511 43.3747 35.2393 44.9284 45.3168 47.3957C47.4246 48.1218 48.7614 47.499 49.3241 45.5306C49.8884 43.564 52.4108 34.1954 56.8912 17.43C57.2715 15.2276 56.5007 13.8735 54.5788 13.3728C52.6586 12.8704 50.2584 12.2785 47.385 11.5938"
      stroke="#E5E6EB"
      strokeWidth="1.72059"
    />
    <path
      d="M37.7652 9.35753L55.0193 14.1511C55.9312 14.404 56.4646 15.3435 56.2185 16.2571L48.3193 45.6034C48.075 46.5067 47.1545 47.0505 46.246 46.8268L28.8921 42.5511C27.9699 42.3257 27.4055 41.3932 27.6309 40.4709C27.6344 40.4589 27.6378 40.4468 27.6395 40.4365L35.6437 10.5705C35.888 9.65175 36.8344 9.10804 37.7514 9.35408C37.7566 9.35581 37.76 9.35753 37.7652 9.35753Z"
      fill="#F7F7F7"
    />
    <path
      d="M16.3456 0.859375H42.1544C44.0539 0.859375 45.5956 2.40102 45.5956 4.30055V33.5506C45.5956 35.4501 44.0539 36.9917 42.1544 36.9917H16.3456C14.4461 36.9917 12.9044 35.4501 12.9044 33.5506V4.30055C12.9044 2.40102 14.4461 0.859375 16.3456 0.859375Z"
      fill="white"
    />
    <path
      d="M16.3456 0.859375H42.1544C44.054 0.859375 45.5956 2.40102 45.5956 4.30055V33.5506C45.5956 35.4501 44.054 36.9917 42.1544 36.9917H16.3456C14.4461 36.9917 12.9044 35.4501 12.9044 33.5506V4.30055C12.9044 2.40102 14.4461 0.859375 16.3456 0.859375Z"
      stroke="#E5E6EB"
      strokeWidth="1.72059"
    />
    <path
      d="M25.8089 8.60156C27.7084 8.60156 29.25 10.1432 29.25 12.0427C29.25 13.9423 27.7084 15.4839 25.8089 15.4839C23.9093 15.4839 22.3677 13.9423 22.3677 12.0427C22.3677 10.1432 23.9093 8.60156 25.8089 8.60156Z"
      fill="white"
    />
    <path
      d="M25.8089 8.60156C27.7084 8.60156 29.25 10.1432 29.25 12.0427C29.25 13.9423 27.7084 15.4839 25.8089 15.4839C23.9093 15.4839 22.3677 13.9423 22.3677 12.0427C22.3677 10.1432 23.9093 8.60156 25.8089 8.60156Z"
      stroke="#1CA3FF"
      strokeWidth="1.72059"
    />
    <path d="M18.9265 30.9705C24.3876 23.9058 21.017 24.637 29.25 29.8779" stroke="#1CA3FF" strokeWidth="1.72059" />
    <path d="M27.5294 27.3932C33.3708 17.3243 29.2724 19.4992 41.2941 27.5274" stroke="#1CA3FF" strokeWidth="1.72059" />
  </svg>
);

export const CameraIcon = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    cursor={"pointer"}
    {...props}
  >
    <g clipPath="url(#clip0_6487_4199)">
      <path
        d="M23 13.9332V8C23 7.46957 22.7893 6.96086 22.4142 6.58579C22.0391 6.21071 21.5304 6 21 6H17L15 3H9L7 6H3C2.46957 6 1.96086 6.21071 1.58579 6.58579C1.21071 6.96086 1 7.46957 1 8V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15.5601"
        stroke={props.color || "white"}
      />
      <path
        d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21.0601 16.4336V22.4336" stroke={props.color || "white"} strokeLinejoin="round" />
      <path d="M24.0601 19.4336H18.0601" stroke={props.color || "white"} strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6487_4199">
        <rect width="24" height="24" fill={props.color || "white"} />
      </clipPath>
    </defs>
  </svg>
);

export const EmptyAlbumIcon = ({ ...props }) => (
  <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.8"
      d="M64.9193 6.10938C97.244 6.10938 123.489 32.3545 123.489 64.6791C123.489 97.0038 97.244 123.249 64.9193 123.249C32.5947 123.249 6.34961 97.0038 6.34961 64.6791C6.34961 32.3545 32.5947 6.10938 64.9193 6.10938Z"
      fill="#EFF0F2"
    />
    <path
      d="M119.001 37.0451C118.384 33.8764 115.287 31.7882 112.118 32.4049L89.0721 36.8895C85.9033 37.5061 83.815 40.6033 84.4317 43.7721L87.7953 61.0565C88.4119 64.2252 91.5096 66.3134 94.6785 65.6967L117.724 61.2121C120.893 60.5954 122.981 57.4983 122.364 54.3295L119.001 37.0451ZM93.0741 42.0904C94.6589 41.782 96.2069 42.8261 96.5157 44.4106C96.8236 45.9949 95.7799 47.5435 94.1951 47.8519C92.6111 48.1601 91.0622 47.1161 90.7542 45.5317C90.4457 43.9473 91.4901 42.3987 93.0741 42.0904ZM119.483 54.89C119.792 56.4744 118.747 58.023 117.163 58.3314L94.6934 62.7039C93.3971 62.9562 92.5129 61.4838 93.209 60.4515L97.3848 54.2571C97.8495 53.5689 98.7134 53.4008 99.402 53.8647L100.434 54.5608C101.122 55.0249 101.986 54.8566 102.451 54.1683L110.107 42.812C110.571 42.1238 111.435 41.9555 112.124 42.4196L117.286 45.8998C117.629 46.1318 117.829 46.392 117.913 46.824L119.483 54.89Z"
      fill="#6F7285"
    />
    <path d="M95.3539 101.753L66.7802 73.5176L61.1221 79.2436L89.6963 107.479L95.3539 101.753Z" fill="#9FA2AF" />
    <path
      d="M106.269 109.339L84.0387 87.3722C83.9149 87.2499 83.7154 87.2511 83.5931 87.3748L75.1788 95.8901C75.0565 96.0138 75.0577 96.2134 75.1814 96.3357L97.4122 118.302C97.536 118.424 97.7355 118.424 97.8578 118.3L106.271 109.784C106.394 109.661 106.393 109.461 106.269 109.339Z"
      fill="#9FA2AF"
    />
    <path
      d="M41.4548 16.5294C21.7968 16.5293 5.86081 32.4653 5.86078 52.1232C5.86074 71.7813 21.7967 87.7172 41.4546 87.7172C61.1127 87.7172 77.0486 71.7814 77.0486 52.1233C77.0486 32.4654 61.1128 16.5294 41.4548 16.5294ZM41.4546 81.9094C25.0042 81.9094 11.6685 68.5738 11.6686 52.1233C11.6686 35.6729 25.0043 22.3372 41.4547 22.3372C57.9052 22.3373 71.2408 35.673 71.2407 52.1234C71.2407 68.5739 57.9051 81.9094 41.4546 81.9094Z"
      fill="#9FA2AF"
    />
    <path
      d="M41.4545 81.9083C57.9049 81.9083 71.2407 68.5726 71.2407 52.1222C71.2407 35.6718 57.905 22.336 41.4546 22.336C25.0042 22.336 11.6684 35.6716 11.6684 52.1221C11.6684 68.5725 25.0041 81.9082 41.4545 81.9083Z"
      fill="white"
    />
    <g opacity="0.95">
      <path
        d="M119.001 37.0451C118.384 33.8764 115.287 31.7882 112.118 32.4049L89.0721 36.8895C85.9033 37.5061 83.815 40.6033 84.4317 43.7721L87.7953 61.0565C88.4119 64.2252 91.5096 66.3134 94.6785 65.6967L117.724 61.2121C120.893 60.5954 122.981 57.4983 122.364 54.3295L119.001 37.0451ZM93.0741 42.0904C94.6589 41.782 96.2069 42.8261 96.5157 44.4106C96.8236 45.9949 95.7799 47.5435 94.1951 47.8519C92.6111 48.1601 91.0622 47.1161 90.7542 45.5317C90.4457 43.9473 91.4901 42.3987 93.0741 42.0904ZM119.483 54.89C119.792 56.4744 118.747 58.023 117.163 58.3314L94.6934 62.7039C93.3971 62.9562 92.5129 61.4838 93.209 60.4515L97.3848 54.2571C97.8495 53.5689 98.7134 53.4008 99.402 53.8647L100.434 54.5608C101.122 55.0249 101.986 54.8566 102.451 54.1683L110.107 42.812C110.571 42.1238 111.435 41.9555 112.124 42.4196L117.286 45.8998C117.629 46.1318 117.829 46.392 117.913 46.824L119.483 54.89Z"
        fill="#9FA2AF"
      />
    </g>
  </svg>
);

export const PersonWithPlusIcon = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 21V19C18 17.9391 17.5786 16.9217 16.8284 16.1716C16.0783 15.4214 15.0609 15 14 15H7C5.93913 15 4.92172 15.4214 4.17157 16.1716C3.42143 16.9217 3 17.9391 3 19V21"
      stroke={props.color || "white"}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 11C12.7091 11 14.5 9.20914 14.5 7C14.5 4.79086 12.7091 3 10.5 3C8.29086 3 6.5 4.79086 6.5 7C6.5 9.20914 8.29086 11 10.5 11Z"
      stroke={props.color || "white"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21 8V14" stroke={props.color || "white"} strokeLinejoin="round" />
    <path d="M24 11H18" stroke={props.color || "white"} strokeLinejoin="round" />
  </svg>
);

export const AssetLoaderIcon = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.3181 2.1875V6.1875" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.3181 18.1875V22.1875" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.24811 5.11768L8.07811 7.94768" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.5581 16.4277L19.3881 19.2577" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.31812 12.1875H6.31812" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.3181 12.1875H22.3181" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.24811 19.2577L8.07811 16.4277" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.5581 7.94768L19.3881 5.11768" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ErrorIcon = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 8V13" stroke="#FF1D4E" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      fill="#061143"
      stroke="#FF1D4E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#FF1D4E"
    />
  </svg>
);

export const CircledCheckMark = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 13L10 16L17 9" stroke="#00EE98" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#00EE98"
    />
  </svg>
);

export const ConnectionLineIcon = () => (
  <svg width="6" height="16" viewBox="0 0 6 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 15.6667C4.47276 15.6667 5.66667 14.4728 5.66667 13C5.66667 11.5272 4.47276 10.3333 3 10.3333C1.52724 10.3333 0.333333 11.5272 0.333333 13C0.333333 14.4728 1.52724 15.6667 3 15.6667ZM3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667ZM3.5 13L3.5 3H2.5L2.5 13H3.5Z"
      fill="#E5E6EB"
    />
  </svg>
);
